var _path, _path2, _path3, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicoffBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6958 18.2173V22.9999",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6957 1C10.681 1 9.70779 1.4031 8.99026 2.12063C8.27273 2.83817 7.86963 3.81135 7.86963 4.82609V11.5217C7.86963 12.5365 8.27273 13.5097 8.99026 14.2272C9.70779 14.9447 10.681 15.3478 11.6957 15.3478C12.7105 15.3478 13.6836 14.9447 14.4012 14.2272C15.1187 13.5097 15.5218 12.5365 15.5218 11.5217V4.82609C15.5218 3.81135 15.1187 2.83817 14.4012 2.12063C13.6836 1.4031 12.7105 1 11.6957 1V1Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3913 8.6521V11.5217C18.3913 13.2975 17.6859 15.0005 16.4302 16.2562C15.1745 17.5119 13.4714 18.2173 11.6957 18.2173C9.91985 18.2173 8.21679 17.5119 6.96111 16.2562C5.70543 15.0005 5 13.2975 5 11.5217V8.6521",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.43244,
    y1: 1.54876,
    x2: 20.7602,
    y2: 18.1545,
    stroke: "white",
    strokeWidth: 1.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicoffBottom);
export default __webpack_public_path__ + "static/media/Micoff-bottom.25595dba.svg";
export { ForwardRef as ReactComponent };